import React from 'react'

import { IconNotebook, IconProps } from '@customTypes'
import { IconType, iconMapper } from '_components/icon/helpers'
import { RequireAtLeastOne } from 'src/types/utils'

type RenderLabel = (htmlFor: string) => JSX.Element

type IconPlacement = 'left' | 'right'

type IconSize = number | string

export type IconData = (Omit<IconProps, 'icon'> & {
  placement: IconPlacement
  key: string
  index?: number
}) &
  (
    | {
        icon: IconNotebook
        renderIcon?: never
      }
    | {
        icon?: never
        renderIcon(): JSX.Element
      }
  )

export type LabelProps = RequireAtLeastOne<
  {
    htmlFor: string
    label?: string
    renderLabel?: RenderLabel
    float?: boolean
    active?: boolean
    hasIcon?: boolean
  },
  'label' | 'renderLabel'
>

export interface IconControllerProps {
  icon?: IconType
  iconGroup?: IconData[]
  clearIcon?: IconNotebook
  renderIcon?(): JSX.Element
  onClickIcon?: React.MouseEventHandler
  iconPlacement?: IconPlacement
  iconSize?: IconSize
  clearable?: boolean
  onClear?: React.MouseEventHandler
  value?: string | number
  iconClassName?: string
  iconControllerClassName?: string
}

export function isLabelProps(
  props:
    | LabelProps
    | {
        htmlFor?: string
        label?: string
        renderLabel?: RenderLabel
      }
): props is LabelProps {
  const { renderLabel, label } = props as LabelProps
  return renderLabel !== undefined || (label !== undefined && label !== '')
}

export function isIcon(icon: IconType | string | undefined): icon is IconType {
  return icon !== undefined && iconMapper.includes(icon as IconType)
}
